import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from 'react'
import * as Icons from '@desenvolvimento-intuix/ui-icons'

// eslint-disable-next-line no-unused-vars
import { IModal, IModalRef } from '../../interfaces/modal'

import { Grid, Container, Section } from './styles'

const ForwardModal: React.ForwardRefRenderFunction<IModalRef, IModal> = (
  {
    children,
    noClickOut = false,
    noCloseButton = false,
    onClose: onCloseProps
  },
  ref
) => {
  const containerRef = useRef(null)

  const [show, setShow] = useState<boolean>(false)

  const onOpen = useCallback(() => {
    setShow(true)
  }, [])

  const onClose = useCallback(() => {
    onCloseProps && onCloseProps()

    setShow(false)
  }, [])

  useImperativeHandle(ref, () => ({
    onOpen,
    onClose
  }))

  const onClickOut = useCallback(
    (event: MouseEvent) => {
      if (noClickOut) return

      const containerEl: Node & Element = containerRef.current!

      if (event.target instanceof Node && containerEl.contains(event.target)) {
        return
      }

      setShow(false)

      onCloseProps && onCloseProps()
    },
    [containerRef]
  )

  useEffect(() => {
    if (show) document.addEventListener('mousedown', onClickOut)

    return () => {
      document.removeEventListener('mousedown', onClickOut)
    }
  }, [onClickOut, show])

  if (!show) return null

  return (
    <Grid className={`modal-grid ${show ? 'show' : ''}`}>
      <Container className='modal-container' ref={containerRef}>
        {!noCloseButton && (
          <button className='modal-close-button' onClick={onClose}>
            <Icons.X />
          </button>
        )}

        <Section>{children}</Section>
      </Container>
    </Grid>
  )
}

const Modal = forwardRef(ForwardModal)

export { Modal }
